import React, { Fragment, VFC, useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { MultiLineStringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { IReduxState } from '../../../ReduxImpl/reducers/index';
import { UpdateCaptchaStatus } from '../../../ReduxImpl/actions/index';
import { useDispatch, useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

export interface MultiLineStringInputViewModelCaptcha
  extends MultiLineStringInputViewModel {
  publicKey?: string;
}
const ReCaptcha: VFC<ValueFieldProps<MultiLineStringInputViewModelCaptcha>> = (
  props
) => {
  const { field } = props;
  const { sitecoreContext } = useSitecoreContext() as {
    sitecoreContext: { [key: string]: string };
  };
  const dispatch = useDispatch();
  const [expired, setExpired] = useState(true);
  const publicKey = field.model.publicKey;

  const scaleCaptcha = useMedia('(max-width: 767px)');
  const onChange = (value: any): void => {
    if (value) {
      setExpired(false);
    } else {
      setExpired(true);
    }
  };

  useEffect(() => {
    dispatch(UpdateCaptchaStatus(expired));
  }, [expired]);

  return (
    <Fragment>
      <script
        src="https://www.google.com/recaptcha/api.js'"
        async
        defer
      ></script>
      <div
        style={
          scaleCaptcha &&
          !field.model.cssClass.includes('ContactUs') &&
          typeof window !== undefined
            ? !window.location.pathname.includes('events')
              ? { transform: 'scale(0.9)', transformOrigin: 'left top' }
              : {}
            : {}
        }
      >
        <ReCAPTCHA
          sitekey={publicKey}
          onChange={onChange}
          hl={sitecoreContext.language}
        />
      </div>
    </Fragment>
  );
};

export default ReCaptcha;
